import { ContactLetter,Wade } from "../ImageLoader";
import DocumentTitle from '../DocumentTitle';
import { Link } from "react-router";

const EMAIL_ADDRESS = "wadeflynn@cwcreations.net";

const Page_About = () => {
    DocumentTitle("CW Creations - Dev Consult Share | About");
    return(<div className='About'>
           <table>
             <tbody>
               <tr><td><img id='portrait' draggable='false' src={Wade} /></td><td><div><p><span className='staffName'>Wade Flynn - Software Developer</span></p><img id='sendEmail' className='interactableimg'src={ContactLetter} onClick={handleEmail}/></div></td></tr>
             </tbody>
           </table>
            
                 
                 <p>I grew up in Northeast Oklahoma on a farm where I learned work ethic and accountability. As many kids, I had an interest for video games and this interest caused me to research how to build video games myself. As a midschool kid, I started writing basic computer scripts and deploying web apps. In 2016 I received my bachelors degree in Computer Science.
                    Immediately I began a professional career in Computer Science, developing software for the public sector. After doing that for several years I now have the desire to work with customers to provide software solutions directly.</p>

          <div id='aboutPolicy'>
            <h2>View our legal policies</h2>
            <div id='policySelection'>
                <Link to="/cookiepolicy"><button >Cookie Policy</button></Link>
                <Link to="/termsofservice"><button>Terms of Service</button></Link>
                <Link to="/privacypolicy"><button>Privacy Policy</button></Link>
            </div>
          </div> 
           </div>);
}

function handleEmail() {
    navigator.clipboard.writeText(EMAIL_ADDRESS);alert('The email address "'+EMAIL_ADDRESS+'" was copied to clipboard.')
}

export default Page_About;